import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { VnextStorageLoggerService } from '@vnext/core/store/logger/vnext-storage-logger.service';
import { environment } from 'src/environments/environment';
import { AppModule } from './app/app.module';

VnextStorageLoggerService.configure(environment.production);

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch(err => {
    console.error(err);
  });
